export const isEntityAccessType = (value) => ['read', 'create', 'update', 'delete'].includes(value);
export const isFieldAccessType = (value) => ['read', 'create', 'update'].includes(value);
//# sourceMappingURL=types.js.map